var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"items":_vm.items,"headers":_vm.headers,"sort-by":"count","sort-desc":"","dense":"","mobile-breakpoint":"0"},scopedSlots:_vm._u([{key:"item.total",fn:function({ item }){return [_c('span',[_vm._v(_vm._s(_vm._f("currency")(item.total)))])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }